
import { computed, defineComponent, PropType } from "vue";
import {
  ProcessTemplateTypesEnum,
} from "@/store/modules/processTemplate/state";
import { t } from "@/i18n";

export default defineComponent({
  name: "ProcessTemplateTypeLabel",
  props: {
    label: {
      type: String as PropType<ProcessTemplateTypesEnum>,
      required: true,
    },
  },
  setup(props) {
    const styleClass = computed(() => {
      if (props.label === ProcessTemplateTypesEnum.ACTIVE) {
        return "tag tag--success";
      }
      if (props.label === ProcessTemplateTypesEnum.DISABLE) {
        return "tag tag--error";
      }
      let label = "status-label ";
      if (props.label === ProcessTemplateTypesEnum.SYSTEM) {
        label += "status-label--system";
      }

      return label;
    });

    const statusLabel = computed(() => {
      const translationKeys: Record<ProcessTemplateTypesEnum, string> = {
        [ProcessTemplateTypesEnum.ACTIVE]: "processTemplateList.type.active",
        [ProcessTemplateTypesEnum.DISABLE]:
          "processTemplateList.type.disabled",
        [ProcessTemplateTypesEnum.SYSTEM]: "processTemplateList.type.system",
      };

      return t(translationKeys[props.label]);
    });

    return {
      statusLabel,
      styleClass,
    };
  },
});
